import styled from 'styled-components'

export const StyledFooter = styled.footer`
  background-color: #eff2f6;
  padding: 4rem 1.8rem 2rem;
`

export const Head = styled.div`
  background-color: ${({ theme, headBgColor }) =>
    headBgColor || theme.colors.primary};
  padding: 8rem 1.4rem 8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;

  align-items: center;
  > * {
    max-width: ${({ headMax }) => (headMax ? headMax : 1000)}px;
    text-align: center;
    color: white;
  }

  > h2 {
    white-space: pre-line;
    margin-bottom: 1.6rem;
  }
  > p {
    font-size: 1.6rem;
    margin-bottom: 1rem;
    max-width: ${({ subMax }) => (subMax ? subMax : 1000)}px;
  }
  > div {
    margin-top: 2rem;
  }
`

export const Row = styled.nav`
  display: flex;
  justify-content: center;
  align-items: space-between;
  flex-wrap: wrap;
  margin: 0 auto;
  max-width: 1100px;
  @media only screen and (max-width: 1156px) {
    align-items: flex-start;
    justify-content: center;
  }
  @media only screen and (max-width: 896px) {
    max-width: 400px;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 220px;
  padding: 3rem 0;
  @media only screen and (max-width: 1156px) {
    &:first-child {
      width: 100%;

      max-width: 900px;
      align-items: center;
    }
    &:nth-child(3) {
      margin: 0 20px;
      @media only screen and (max-width: 896px) {
        margin: 0;
      }
    }
    width: 190px;
    
  }
  .logo {
    min-width: 260px;
    img {
      width: 100%;
      max-width: 190px;
    }
    @media only screen and (max-width: 1156px) {
      min-width: auto;
      margin-left: -95px;
      img {
        max-width: 190px; 
      }
    }
    @media only screen and (max-width: 896px) {
      margin: 0;
      img {
        max-width: 190px; 
      }
    }
  }

  .contact {
    > div { margin-bottom: 20px; }
  }

  @media only screen and (max-width: 896px) {
    min-width: 80%;
    min-width: 260px;
    max-width: 260px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > h1 {
    color: #1a1a1a;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 34px;
  }
  > a {
    color: #1a1a1a;
    text-decoration: none;
    font-size: 16px;
    margin-bottom: 16px;
  }

    p {
      color: #1a1a1a;
      text-decoration: none;
      font-size: 16px;
      margin-bottom: 10px;
    }
    > div {
      margin: 0 30px 12px 0;
      @media only screen and (max-width: 1156px) {
        margin: 0;
      }
    }
    a {
      color: #2474e8;
      font-size: 16px;
      &:hover {
        filter: brightness(1.2);
      }
    }
  }
`
export const FooterBottom = styled.div`
  border-top: 1px solid #b6b6b6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.6rem;
  max-width: 1100px;
  margin: 3rem auto 0;
  @media only screen and (max-width: 535px) {
    flex-direction: column;
  }
`

export const Links = styled.nav`
  > a {
    transition: 300ms all linear;
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
    text-decoration: none;
    margin-right: 24px;
    &:hover {
      color: ${({ theme }) => theme.colors.active1};
    }
  }
  @media only screen and (max-width: 535px) {
    padding: 1rem 0 2rem;

    > a {
      margin: 0 12px;
    }
  }
`

export const Socials = styled.div`
  a {
    margin-left: 2rem;
    transition: 300ms all linear;
    @media only screen and (max-width: 535px) {
      margin: 0rem;
      padding: 1rem;
    }
    &:hover {
      > svg {
        .outer-path {
          fill: ${({ theme }) => theme.colors.active1};
        }
      }
    }
    > svg {
      cursor: pointer;
      transition: 300ms fill linear;
    }
  }
`
